import styled, { css, keyframes } from 'styled-components';
import { C as ClassNamePassthrough } from '../LocalModules/storm-ui-utils/dist/esm/ClassNamePassthrough-BOut0eKj-BOut0eKj.js';

const spinAnimation = /*#__PURE__*/keyframes(["0%{/*! @noflip */ transform:rotate(0deg);}to{/*! @noflip */ transform:rotate(1turn);}"]);
const spinStyle = /*#__PURE__*/css(["@media (prefers-reduced-motion:no-preference){animation:spin 0.8s linear infinite;animation-name:", ";}"], spinAnimation);

/**
 * The Icon colors are not in a central place in the theme
 * so this function checks all the areas to get the color
 */
const getIconColor = (theme, color) => {
  // color: 'ai'
  if (color === 'ai') {
    // This is where the token we need is for now.
    // until AI stuff gets it's own tokens, this is what we're using.
    return theme.dataVisualizationColor.categorical.violet.default;
  }
  // color: 'info' | 'error' | 'success' | 'warning'
  return theme.support.iconColor[color]
  // color: 'default', 'secondary', 'tertiary', 'unavailable', 'inverted'
  || theme.icon.color[color]
  // color: 'inherit'
  || color;
};
const IconClassWrapper = /*#__PURE__*/styled(ClassNamePassthrough).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1gsqp3h-0"
})(["height:1em;width:1em;display:inline-flex;justify-content:center;:not(:root){overflow:visible;}", " ", ";color:", ";vertical-align:", "em;"], ({
  $spin
}) => $spin ? spinStyle : null, ({
  $fontSize
}) => $fontSize ? `font-size: ${$fontSize}` : null, ({
  theme,
  $color
}) => getIconColor(theme, $color), ({
  $size
}) => $size === 'large' ? '-0.225' : '-0.125');
const IconWrapperStyled = /*#__PURE__*/styled('i').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1gsqp3h-1"
})(["display:inline-flex;", " justify-content:center;align-items:center;> svg{display:block;circle{opacity:0.25;}}", ""], ({
  $isClickTarget
}) => $isClickTarget && css(["min-height:24px;min-width:24px;"]),
// Only use the icon RTL flipper when using a logical direction icon type;
({
  $horizontalFlipOnRTL
}) => $horizontalFlipOnRTL ? css(["/*! @noflip */ [dir=\"rtl\"] && > svg{/*! @noflip */ transform:scaleX(-1);}"]) : '');

export { IconClassWrapper as I, IconWrapperStyled as a };
//# sourceMappingURL=Icon.styles-BxPGBwBy.js.map
